import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

export default function LegacyCreateTravelTrackRedirect() {
    const { userId = "" } = useParams();
    const location = useLocation();

    return (
        <Navigate
            replace
            to={{
                pathname: `/userlk/${encodeURIComponent(userId)}/usertravelplans`,
                search: location.search,
                hash: location.hash,
            }}
        />
    );
}
